/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CookieConsentCategories } from './CookieConsentCategories';
import {
    CookieConsentCategoriesFromJSON,
    CookieConsentCategoriesFromJSONTyped,
    CookieConsentCategoriesToJSON,
    CookieConsentCategoriesToJSONTyped,
} from './CookieConsentCategories';

/**
 * Account-level cookie-consent record. Persisted so a signed-in user's choice follows them across storage evictions, browsers, and devices instead of living only in per-origin browser storage.
 * @export
 * @interface CookieConsent
 */
export interface CookieConsent {
    /**
     * 
     * @type {CookieConsentCategories}
     * @memberof CookieConsent
     */
    categories: CookieConsentCategories;
    /**
     * US 'Do Not Sell/Share' + GPC signal. True = user opted out of sale/sharing.
     * @type {boolean}
     * @memberof CookieConsent
     */
    doNotSell?: boolean;
    /**
     * Unix ms timestamp of the consent decision.
     * @type {number}
     * @memberof CookieConsent
     */
    acceptedAt: number;
    /**
     * Live Termly policy-document version(s) at capture — a composite of the per-document versions read from Termly's own cache, NOT a hand-maintained constant. Audit/informational only; the re-prompt on a policy bump is Termly's own behavior (it re-notifies when its live version exceeds the consented one), not gated on this field. May be absent if the version wasn't readable at capture.
     * @type {string}
     * @memberof CookieConsent
     */
    policyVersion?: string;
    /**
     * ISO country code detected server-side (cf-ipcountry) at capture. Suppression is skipped when the user's current country differs, so a US-style opt-out record is not silently applied under a stricter regime.
     * @type {string}
     * @memberof CookieConsent
     */
    jurisdiction?: string;
    /**
     * Whether the decision came from the initial banner or a later Cookie Preferences edit. Allowed values: banner, preferences (enforced server- and model-side).
     * @type {string}
     * @memberof CookieConsent
     */
    source?: string;
    /**
     * Opaque JSON of the user's Termly consent-bearing localStorage entries (TERMLY_* + __tluid), captured verbatim so the exact browser state can be restored before Termly initializes on a new device — schema-agnostic, never parsed server-side.
     * @type {string}
     * @memberof CookieConsent
     */
    termlySnapshot?: string;
}

/**
 * Check if a given object implements the CookieConsent interface.
 */
export function instanceOfCookieConsent(value: object): value is CookieConsent {
    if (!('categories' in value) || value['categories'] === undefined) return false;
    if (!('acceptedAt' in value) || value['acceptedAt'] === undefined) return false;
    return true;
}

export function CookieConsentFromJSON(json: any): CookieConsent {
    return CookieConsentFromJSONTyped(json, false);
}

export function CookieConsentFromJSONTyped(json: any, ignoreDiscriminator: boolean): CookieConsent {
    if (json == null) {
        return json;
    }
    return {
        
        'categories': CookieConsentCategoriesFromJSON(json['categories']),
        'doNotSell': json['doNotSell'] == null ? undefined : json['doNotSell'],
        'acceptedAt': json['acceptedAt'],
        'policyVersion': json['policyVersion'] == null ? undefined : json['policyVersion'],
        'jurisdiction': json['jurisdiction'] == null ? undefined : json['jurisdiction'],
        'source': json['source'] == null ? undefined : json['source'],
        'termlySnapshot': json['termlySnapshot'] == null ? undefined : json['termlySnapshot'],
    };
}

export function CookieConsentToJSON(json: any): CookieConsent {
    return CookieConsentToJSONTyped(json, false);
}

export function CookieConsentToJSONTyped(value?: CookieConsent | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'categories': CookieConsentCategoriesToJSON(value['categories']),
        'doNotSell': value['doNotSell'],
        'acceptedAt': value['acceptedAt'],
        'policyVersion': value['policyVersion'],
        'jurisdiction': value['jurisdiction'],
        'source': value['source'],
        'termlySnapshot': value['termlySnapshot'],
    };
}

